import React, { useEffect, useRef, useState } from 'react'
import CommonButton from '../../../components/commonButton';
import { ArrowLeftIcon, Delete02Icon, EditIcon, LocationIcon, VerifiedIcon } from '../../../assets/icons';
import { createPortal } from 'react-dom';
import "./index.css"
import CustomTabs from '../../../components/custom-tabs/CustomTabs';
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { goBack } from '../../../utils/otherHelopers';
import { USER_DETAIL_TABS } from './constants';
import Overview from './tabs/Overview';
import StatusChip from '../../../components/statusChip/StatusChip';
import { Check, Mail, Phone, Lock, UserCheck, UserX, Trash2, Star, RotateCcw, BadgeCheck } from 'lucide-react';
import Profile from './tabs/Profile';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserDetail, resetUserDetail, updateUserDetails, removeUserPhoto, patchUserPhoto, changeUserStatus, deleteAppUser, manualVerifyUserIdentity, unverifyUserIdentity, changeUserPassword, changeUserStarStatus, reverseUserSubscription } from '../../../redux/slice/allUsersSlice';
import { useLoader } from '../../../context/LoaderContext';
import { formatMomentDate } from '../../../utils/dateHelper';
import DeletePopup from '../../../components/delete-popup';
import Posts from './tabs/Posts';
import PublicProperties from './tabs/PublicProperties';
import Subscriptions from './tabs/profile/Subscriptions';
import Verifications from './tabs/profile/Verifications';
import BrokerCRM from './tabs/BrokerCRM';
import EditProfileModal from '../../../components/modals/UserProfile/EditProfileModal';
import AboutModal from '../../../components/modals/UserProfile/AboutModal';
import AssignPlanModal from '../../../components/modals/AssignPlanModal';
import PreviewModal from '../../../components/modals/previewModal';
import PasswordChangeModal from '../../../components/modals/PasswordChangeModal';
import ConfirmModal from '../../../components/withModal/ConfirmModal';
import { useToast } from '../../../context/TostContext';
import { getUserInitial, getUserInitialColors } from '../../../utils/otherHelopers';

const renderHeaderContent = (onBack, onEditClick) => (
    <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex align-items-center gap-2">
            <button
                onClick={onBack}
                type="button"
                className="border-0 bg-transparent p-0 d-flex align-items-center justify-content-center primary"
            >
                <ArrowLeftIcon size={22} />
            </button>
            <h4 className="fw-semibold mb-0 text-primary fs-lg">
                User Details
            </h4>
        </div>
        {/* <div className="action-buttons-container d-flex align-items-center gap-3">
            <CommonButton
                icon={<EditIcon strokeWidth="2.0" />}
                variant="secondary"
                className=""
                title="Edit User"
                type="button"
                onClick={onEditClick}
            />
            <CommonButton
                variant="primary"
                title="Broker CRM"
                type="button"
                onClick={() => { }}
            />
        </div> */}
    </div>
);

const renderTabContent = (activeTab, onEditAbout, userDetail) => {
    switch (activeTab) {
        case "overview":
            return <Overview onEditAbout={onEditAbout} />;
        case "profile":
            return <Profile onEditAbout={onEditAbout} />;
        case "posts":
            return <Posts />;
        case "public-properties":
            return <PublicProperties isLand={false} />;
        case "public-lands":
            return <PublicProperties isLand={true} />;
        case "broker-crm":
            return <BrokerCRM />;
        case "subscriptions":
            return <Subscriptions userDetail={userDetail} />;
        case "verifications":
            return <Verifications userDetail={userDetail} />;
        default:
            return <div className="p-4 bg-white rounded-3"><h6>Overview</h6><p className="text-muted mb-0">User overview content will appear here.</p></div>;
    }
};

const UserDetails = () => {
    const { id } = useParams();
    const toast = useToast();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { setLoading } = useLoader();
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || USER_DETAIL_TABS[0]?.key;

    const coverInputRef = useRef(null);
    const profileInputRef = useRef(null);
    const [uploadingPhoto, setUploadingPhoto] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [previewMedia, setPreviewMedia] = useState(null);
    const [showAboutModal, setShowAboutModal] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showAssignPlanModalHeader, setShowAssignPlanModalHeader] = useState(false);
    const [deletePopupConfig, setDeletePopupConfig] = useState({
        show: false,
        title: "",
        content: "",
        saveTitle: "Delete",
        onConfirm: () => { },
    });
    const [confirmModalConfig, setConfirmModalConfig] = useState({
        isOpen: false,
        title: "",
        message: "",
        onConfirm: () => { },
        confirmText: "Yes",
        cancelText: "No",
    });

    const handlePhotoUpload = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 5 * 1024 * 1024) {
            toast.error('File size cannot exceed 5MB.');
            return;
        }
        const previewUrl = URL.createObjectURL(file);
        const formData = new FormData();
        formData.append(type, file);
        setUploadingPhoto(type);
        dispatch(updateUserDetails({ id: id, data: formData }))
            .unwrap()
            .then(() => {
                dispatch(patchUserPhoto({ type, photoData: { url: previewUrl, key: null } }));
                toast.success(`${type === 'cover_photo' ? 'Cover' : 'Profile'} photo updated successfully`);
            })
            .catch((error) => {
                URL.revokeObjectURL(previewUrl);
                toast.error(error?.message || `Failed to update ${type === 'cover_photo' ? 'cover' : 'profile'} photo`);
            })
            .finally(() => {
                setUploadingPhoto(null);
            });
        e.target.value = null;
    };

    const confirmRemovePhoto = (type) => {
        dispatch(removeUserPhoto({ id: id, type }))
            .unwrap()
            .then(() => {
                dispatch(patchUserPhoto({ type, photoData: null }));
                toast.success(`${type === 'cover_photo' ? 'Cover' : 'Profile'} photo removed successfully`);
                setDeletePopupConfig((prev) => ({ ...prev, show: false }));
            })
            .catch((error) => {
                toast.error(error?.message || 'Failed to remove photo');
                setDeletePopupConfig((prev) => ({ ...prev, show: false }));
            });
    };

    const handleRemovePhoto = (type) => {
        setDeletePopupConfig({
            show: true,
            title: `Remove ${type === 'cover_photo' ? 'Cover' : 'Profile'} Photo`,
            content: `Are you sure you want to remove the ${type === 'cover_photo' ? 'cover' : 'profile'} photo?`,
            saveTitle: "Remove",
            onConfirm: () => confirmRemovePhoto(type),
        });
    };
    const headerPortalTarget = document.getElementById("header-portal-target");

    const { userDetail, updateUserLoading } = useSelector((state) => state.allUsers);

    const handleUpsertUserProfile = (data) => {
        dispatch(updateUserDetails({ id: id, data }))
            .unwrap()
            .then(() => {
                toast.success("Profile updated successfully");
                setShowEditModal(false);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to update profile");
            });
    };

    const handleUpdateAbout = (aboutText) => {
        const formData = new FormData();
        formData.append("about", aboutText);
        dispatch(updateUserDetails({ id: id, data: formData }))
            .unwrap()
            .then(() => {
                toast.success("About info updated successfully");
                setShowAboutModal(false);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to update about info");
            });
    };

    const handleStatusChange = () => {
        if (!userDetail) return;
        const newStatus = userDetail.status === "active" ? "inactive" : "active";
        dispatch(changeUserStatus({ id: id, status: newStatus }))
            .unwrap()
            .then(() => {
                toast.success(`User successfully ${newStatus === "active" ? "activated" : "deactivated"}`);
                setDeletePopupConfig((prev) => ({ ...prev, show: false }));
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to change user status");
                setDeletePopupConfig((prev) => ({ ...prev, show: false }));
            });
    };

    const handleVerifyIdentity = () => {
        if (!userDetail) return;
        setConfirmModalConfig({
            isOpen: true,
            title: "Verify Identity",
            message: "Are you sure you want to verify this user's identity?",
            confirmText: "Verify",
            cancelText: "Cancel",
            onConfirm: () => {
                dispatch(manualVerifyUserIdentity(userDetail.id))
                    .unwrap()
                    .then(() => {
                        toast.success("User identity verified successfully");
                    })
                    .catch((error) => {
                        toast.error(error?.message || "Failed to verify identity");
                    });
            }
        });
    };

    const handleUnverifyIdentity = () => {
        if (!userDetail) return;
        setConfirmModalConfig({
            isOpen: true,
            title: "Unverify User Identity",
            message: "Are you sure you want to remove this user's manual verification? The user will no longer be marked as identity verified.",
            confirmText: "Unverify",
            cancelText: "Cancel",
            onConfirm: () => {
                dispatch(unverifyUserIdentity(userDetail.id))
                    .unwrap()
                    .then(() => {
                        toast.success("User identity unverified successfully");
                        setConfirmModalConfig((prev) => ({ ...prev, isOpen: false }));
                    })
                    .catch((error) => {
                        toast.error(error?.message || "Failed to unverify identity");
                        setConfirmModalConfig((prev) => ({ ...prev, isOpen: false }));
                    });
            }
        });
    };

    const handleStarStatusChange = () => {
        const newStatus = !userDetail?.is_star;
        setConfirmModalConfig({
            isOpen: true,
            title: newStatus ? "Mark as Star User" : "Remove Star Status",
            message: `Are you sure you want to ${newStatus ? "mark this user as a star user" : "remove star status from this user"}?`,
            confirmText: newStatus ? "Mark Star" : "Remove Star",
            cancelText: "Cancel",
            onConfirm: () => {
                dispatch(changeUserStarStatus({ id: id, is_star: newStatus }))
                    .unwrap()
                    .then((res) => {
                        toast.success(res.message || "Star status updated successfully");
                    })
                    .catch((error) => {
                        toast.error(error?.message || "Failed to update star status");
                    });
            }
        });
    };

    const handleDeleteUser = () => {
        dispatch(deleteAppUser(id))
            .unwrap()
            .then(() => {
                toast.success("User deleted successfully");
                setDeletePopupConfig((prev) => ({ ...prev, show: false }));
                if (userDetail?.is_migrated) {
                    navigate("/user/mep");
                } else {
                    navigate("/user/r-point");
                }
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete user");
                setDeletePopupConfig((prev) => ({ ...prev, show: false }));
            });
    };

    const handleReversePlan = () => {
        if (!userDetail?.subscription?.id) return;
        setConfirmModalConfig({
            isOpen: true,
            title: "Revoke Subscription Plan",
            message: "Are you sure you want to revoke this admin-assigned subscription? Premium features will be deactivated immediately.",
            confirmText: "Revoke",
            cancelText: "Cancel",
            onConfirm: () => {
                dispatch(reverseUserSubscription({ subscription_id: userDetail.subscription.id }))
                    .unwrap()
                    .then((res) => {
                        toast.success(res?.message || "Subscription revoked successfully");
                        setConfirmModalConfig((prev) => ({ ...prev, isOpen: false }));
                        dispatch(fetchUserDetail(id));
                    })
                    .catch((error) => {
                        toast.error(error?.message || "Failed to revoke subscription");
                        setConfirmModalConfig((prev) => ({ ...prev, isOpen: false }));
                    });
            }
        });
    };

    useEffect(() => {
        if (!id) return;
        dispatch(resetUserDetail());
        setLoading(true);
        dispatch(fetchUserDetail(id))
            .then(() => {
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching user details:", err);
                setLoading(false);
            });
    }, [dispatch, setLoading, id]);

    useEffect(() => {
        return () => {
            dispatch(resetUserDetail());
        };
    }, [dispatch]);

    if (!userDetail) {
        return null;
    }

    const handleBack = () => {
        goBack(navigate, location, userDetail?.is_migrated ? "/user/mep" : "/user/r-point");
    };

    return (<>
        {headerPortalTarget && createPortal(renderHeaderContent(handleBack, () => setShowEditModal(true)), headerPortalTarget)}
        <section className='overflow-hidden user-details-page'>
            <div className="grid ">
                <div className="g-col-9 overflow-auto scroll-0">
                    {/* Profile Section */}
                    <div className="overflow-hidden position-relative mb-30 bg-white rounded-3 ">
                        {/* Cover Photo */}
                        <div className="position-relative profile-cover g-col-2">
                            <img
                                src={userDetail?.profile?.cover_photo?.url || "/images/AllUser/UserHeader.png"}
                                alt="cover"
                                className="w-100 h-100"
                                style={{ objectFit: 'cover' }}
                            />
                            <input
                                ref={coverInputRef}
                                type="file"
                                className="d-none"
                                accept="image/*"
                                onChange={(e) => handlePhotoUpload(e, 'cover_photo')}
                            />
                            <div
                                className={`position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center cover-photo-overlay${uploadingPhoto === 'cover_photo' ? ' cover-photo-overlay--loading' : ''}`}
                                onClick={(e) => {
                                    if (e.target === e.currentTarget) {
                                        setPreviewMedia([{
                                            url: userDetail?.profile?.cover_photo?.url || "/images/AllUser/UserHeader.png",
                                            title: "Cover Photo",
                                            type: "image"
                                        }]);
                                    }
                                }}
                            >
                                {uploadingPhoto === 'cover_photo' ? (
                                    <div className="photo-upload-spinner" />
                                ) : (
                                    <>
                                        <div
                                            className="bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center avatar-action-btn"
                                            onClick={() => coverInputRef.current?.click()}
                                            title="Change Cover Photo"
                                        >
                                            <EditIcon width={14} height={14} color="#333" />
                                        </div>
                                        {userDetail?.profile?.cover_photo?.url && (
                                            <button
                                                className="bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center avatar-action-btn"
                                                onClick={() => handleRemovePhoto('cover_photo')}
                                                title="Remove Cover Photo"
                                            >
                                                <Delete02Icon size={14} />
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Profile Card */}
                        <div className="p-4 grid gap-3 shadow-none">
                            <div className="g-col-2 text-center" style={{ gridRow: "span 2" }}>
                                <div className="position-relative rounded-circle overflow-hidden profile-avatar-wrapper">
                                    {userDetail?.profile?.profile_photo?.url ? (
                                        <img src={userDetail?.profile?.profile_photo?.url} alt={userDetail?.first_name + " " + userDetail?.last_name} className='w-100 h-100' />
                                    ) : (
                                        (() => {
                                            const fullName = `${userDetail?.first_name || ""} ${userDetail?.last_name || ""}`.trim();
                                            const palette = getUserInitialColors(fullName);
                                            return (
                                                <span
                                                    className="d-flex align-items-center justify-content-center w-100 h-100 fw-bold fs-4"
                                                    style={{ backgroundColor: palette.bg, color: palette.color }}
                                                >
                                                    {getUserInitial(fullName)}
                                                </span>
                                            );
                                        })()
                                    )}
                                    <div
                                        className={`position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center profile-avatar-overlay${uploadingPhoto === 'profile_photo' ? ' profile-avatar-overlay--loading' : ''}`}
                                        onClick={(e) => {
                                            if (e.target === e.currentTarget && userDetail?.profile?.profile_photo?.url) {
                                                setPreviewMedia([{
                                                    url: userDetail.profile.profile_photo.url,
                                                    title: "Profile Photo",
                                                    type: "image"
                                                }]);
                                            }
                                        }}
                                    >
                                        {uploadingPhoto === 'profile_photo' ? (
                                            <div className="photo-upload-spinner" />
                                        ) : (
                                            <>
                                                <div
                                                    className="bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center avatar-action-btn"
                                                    onClick={() => profileInputRef.current?.click()}
                                                    title="Change Profile Photo"
                                                >
                                                    <EditIcon width={14} height={14} color="#333" />
                                                </div>
                                                {userDetail?.profile?.profile_photo?.url && (
                                                    <button
                                                        className="bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center avatar-action-btn"
                                                        onClick={() => handleRemovePhoto('profile_photo')}
                                                        title="Remove Profile Photo"
                                                    >
                                                        <Delete02Icon size={14} />
                                                    </button>
                                                )}
                                            </>
                                        )}
                                    </div>
                                    <span className="position-absolute rounded-circle online-indicator"></span>
                                    <input
                                        ref={profileInputRef}
                                        type="file"
                                        className="d-none"
                                        accept="image/*"
                                        onChange={(e) => handlePhotoUpload(e, 'profile_photo')}
                                    />
                                </div>
                                {/* Active Badge */}
                                {/* <span className="verified-badge d-inline-flex align-items-center gap-1 mt-3">
                                    <Check size={12} />
                                    {userDetail?.status === "active" ? "Active" : "Inactive"}
                                </span> */}
                            </div>
                            <div className="g-col-10 d-flex flex-column justify-content-center">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <div className="d-flex align-items-center gap-2">
                                        <h5 className="mb-0 profile-user-name">
                                            {userDetail?.first_name ? `${userDetail.first_name} ${userDetail.last_name || ""}`.trim() : "-"}
                                        </h5>
                                        {userDetail?.identity_verified && (
                                            <VerifiedIcon size={20} className="text-success" />
                                        )}
                                        {userDetail?.is_star && (
                                            <Star size={20} className='text-warning' />
                                        )}
                                    </div>
                                    {userDetail?.status && (
                                        <StatusChip
                                            pill
                                            bg={userDetail.status === "active" ? "success" : "danger"}
                                            title={userDetail.status.toUpperCase()}
                                        />
                                    )}
                                </div>
                                <p className="mb-0 mt-1 profile-role text-muted">{userDetail?.profile?.profession?.name || "-"}</p>
                            </div>
                            {/* Left: Avatar + Info */}
                            <div className="profile-info-left g-col-3 border-end pe-3">

                                {/* Bio */}
                                {/* <p className="mb-3 profile-bio">
                                    {userDetail?.profile?.about || "No bio added yet."}
                                </p> */}

                                {/* Contact Info */}
                                <div className="d-flex flex-column contact-list">
                                    <div className="d-flex align-items-center contact-item" title={userDetail?.email || ""}>
                                        <Mail width={14} height={14} color="#888" className="flex-shrink-0" />
                                        <span className="contact-text text-truncate">{userDetail?.email || "-"}</span>
                                        {userDetail?.email_verified ? (
                                            <span className="d-flex align-items-center contact-verified ms-2 flex-shrink-0">
                                                <Check />
                                                Email Verified
                                            </span>
                                        ) : null}
                                    </div>
                                    <div className="d-flex align-items-center contact-item" title={userDetail?.mobile_number || ""}>
                                        <Phone width={14} height={14} color="#888" className="flex-shrink-0" />
                                        <span className="contact-text text-truncate">{userDetail?.mobile_number || "-"}</span>
                                        {userDetail?.mobile_verified ? (
                                            <span className="d-flex align-items-center contact-verified ms-2 flex-shrink-0">
                                                <Check />
                                                Mobile Verified
                                            </span>
                                        ) : null}
                                    </div>
                                    <div className="d-flex align-items-center contact-item primary" title={
                                        userDetail?.profile?.city?.name
                                            ? `${userDetail.profile.city.name}${userDetail.profile.city.state?.name ? `, ${userDetail.profile.city.state.name}` : ""}`
                                            : userDetail?.city?.name || ""
                                    }>
                                        <LocationIcon size={14} className="flex-shrink-0" />
                                        <span className="contact-text text-truncate">
                                            {userDetail?.profile?.city?.name
                                                ? `${userDetail.profile.city.name}${userDetail.profile.city.state?.name ? `, ${userDetail.profile.city.state.name}` : ""}`
                                                : userDetail?.city?.name || "-"}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Right: Detail Grid */}

                            {/* Column 1 */}
                            <div className="d-flex flex-column flex-fill detail-column g-col-4 border-end pe-3">
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">User ID</span>
                                    <span className="detail-value text-break">{userDetail?.id || "-"}</span>
                                </div>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">Created At</span>
                                    <span className="detail-value">{formatMomentDate(userDetail?.created_at, "DD MMM YYYY, hh:mm A")}</span>
                                </div>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">Last Updated At</span>
                                    <span className="detail-value">{formatMomentDate(userDetail?.updated_at, "DD MMM YYYY, hh:mm A")}</span>
                                </div>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">Last Login</span>
                                    <span className="detail-value">{formatMomentDate(userDetail?.last_login_at, "DD MMM YYYY, hh:mm A")}</span>
                                </div>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">Last Active</span>
                                    <span className="detail-value">{formatMomentDate(userDetail?.last_active_at, "DD MMM YYYY, hh:mm A")}</span>
                                </div>
                            </div>

                            {/* Column 2 */}
                            <div className="d-flex flex-column flex-fill detail-column g-col-3" style={{ minWidth: "270px" }}>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">Subscription Plan</span>
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="badge-premium bg-primary text-white px-2 py-1 rounded" style={{ fontSize: '11px', fontWeight: 500 }}>
                                            {userDetail?.subscription?.plan_name || "Free"}
                                        </span>
                                        {(!userDetail?.subscription || userDetail.subscription.plan_type === "free") && (
                                            <button
                                                className="btn btn-sm btn-outline-warning d-flex align-items-center gap-1 p-0 px-1 rounded shadow-sm"
                                                style={{ fontSize: '10px', height: '22px' }}
                                                onClick={() => setShowAssignPlanModalHeader(true)}
                                            >
                                                ⚡ Upgrade
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">Subscription Status</span>
                                    <StatusChip className="text-capitalize" bg={userDetail?.subscription?.status === 'active' || userDetail?.subscription?.status === 'trialing' ? "success" : "danger"} title={userDetail?.subscription?.status} />
                                </div>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">Start Date</span>
                                    <span className="detail-value">{formatMomentDate(userDetail?.subscription?.start_date, "DD MMM YYYY, hh:mm A")}</span>
                                </div>
                                <div className="d-flex align-items-start detail-row">
                                    <span className="detail-label">End Date</span>
                                    <span className="detail-value">{formatMomentDate(userDetail?.subscription?.end_date, "DD MMM YYYY, hh:mm A")}</span>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <div className="g-col-3 overflow-auto scroll-0">
                    <div className="border bg-white p-3 shadow-md rounded-3">
                        <h6>Quick Actions</h6>
                        <div className="grid gap-2 mt-3">
                            <CommonButton title="Edit Details" icon={<EditIcon width={16} height={16} />} className="g-col-12" variant="primary" onClick={() => setShowEditModal(true)} />
                            <CommonButton title="Change Password" icon={<Lock size={16} />} className="g-col-12" variant="secondary" onClick={() => setShowChangePassword(true)} />
                            {!userDetail?.identity_verified && (
                                <CommonButton
                                    title="Verify Identity"
                                    icon={<BadgeCheck size={16} />}
                                    className="g-col-12"
                                    variant="success"
                                    onClick={handleVerifyIdentity}
                                />
                            )}
                            {userDetail?.subscription?.status === 'active' && userDetail?.subscription?.created_by_type === 'admin' && (
                                <CommonButton
                                    title="Revoke Plan"
                                    icon={<RotateCcw size={16} />}
                                    className="g-col-12"
                                    variant="outline-danger"
                                    onClick={handleReversePlan}
                                />
                            )}
                            {userDetail?.identity_verified && userDetail?.identity_verified_by_type === 'admin' && (
                                <CommonButton
                                    title="Unverify User"
                                    icon={<UserX size={16} />}
                                    className="g-col-12"
                                    variant="outline-danger"
                                    onClick={handleUnverifyIdentity}
                                />
                            )}
                            <CommonButton
                                title={userDetail?.is_star ? "Remove Star Status" : "Mark as Star User"}
                                icon={<Star size={16} fill={userDetail?.is_star ? "currentColor" : "none"} />}
                                className="g-col-12"
                                variant={userDetail?.is_star ? "warning" : "outline-warning"}
                                onClick={handleStarStatusChange}
                            />
                            <CommonButton
                                title={userDetail?.status === "active" ? "Deactivate User" : "Activate User"}
                                icon={userDetail?.status === "active" ? <UserX size={16} /> : <UserCheck size={16} />}
                                className="g-col-12"
                                variant={userDetail?.status === "active" ? "outline-danger" : "outline-success"}
                                onClick={() => {
                                    const isActive = userDetail?.status === "active";
                                    setDeletePopupConfig({
                                        show: true,
                                        title: isActive ? "Deactivate User" : "Activate User",
                                        content: "Are you sure you want to change the status of this user?",
                                        saveTitle: isActive ? "Deactivate" : "Activate",
                                        onConfirm: handleStatusChange,
                                    });
                                }}
                            />
                            <CommonButton
                                title="Delete User"
                                icon={<Trash2 size={16} />}
                                className="g-col-12"
                                variant="danger"
                                onClick={() => {
                                    setDeletePopupConfig({
                                        show: true,
                                        title: "Delete User",
                                        content: "Are you sure you want to delete this user? This action cannot be undone.",
                                        saveTitle: "Delete",
                                        onConfirm: handleDeleteUser,
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* Tabs Section */}
            <CustomTabs
                variant="underline"
                items={USER_DETAIL_TABS}
                accessor="tab"
                onChange={(key) => {
                    const updated = new URLSearchParams(searchParams);
                    updated.set("tab", key);
                    if (key !== "profile") {
                        updated.delete("profile-tabs");
                    }
                    if (key !== "broker-crm") {
                        updated.delete("broker-tabs");
                    }
                    if (key !== "subscriptions") {
                        updated.delete("subscription-id");
                    }
                    setSearchParams(updated);
                }}
            />

            {/* Dynamic Tabs Content */}
            <div className="mt-4">
                {renderTabContent(activeTab, () => setShowAboutModal(true), userDetail)}
            </div>
        </section>



        <EditProfileModal
            isOpen={showEditModal}
            onClose={() => setShowEditModal(false)}
            onSubmit={handleUpsertUserProfile}
            user={userDetail}
            isLoading={updateUserLoading}
            title="Edit Profile"
            size="lg"
        />

        <AboutModal
            isOpen={showAboutModal}
            onClose={() => setShowAboutModal(false)}
            onSubmit={handleUpdateAbout}
            about={userDetail?.profile?.about}
            isLoading={updateUserLoading}
            title="Edit About"
            size="lg"
        />

        {showChangePassword && (<PasswordChangeModal
            isOpen={showChangePassword}
            onClose={() => setShowChangePassword(false)}
            onSubmit={async (newPassword) => {
                const result = await dispatch(changeUserPassword({ id: userDetail?.id, password: newPassword }));
                if (changeUserPassword.rejected.match(result)) {
                    throw new Error(result.payload?.message || "Failed to change password");
                }
            }}
            title={`Change Password for ${userDetail?.first_name || ""} ${userDetail?.last_name || ""}`}
        />)}

        <AssignPlanModal
            isOpen={showAssignPlanModalHeader}
            onClose={() => setShowAssignPlanModalHeader(false)}
            userId={id || userDetail?.id}
            title="ASSIGN PLAN"
            className="tp-file-modal"
        />
        <DeletePopup
            show={deletePopupConfig.show}
            onHide={() => setDeletePopupConfig((prev) => ({ ...prev, show: false }))}
            title={deletePopupConfig.title}
            content={deletePopupConfig.content}
            saveTitle={deletePopupConfig.saveTitle}
            onConfirm={deletePopupConfig.onConfirm}
        />
        <ConfirmModal
            isOpen={confirmModalConfig.isOpen}
            onClose={() => setConfirmModalConfig((prev) => ({ ...prev, isOpen: false }))}
            title={confirmModalConfig.title}
            message={confirmModalConfig.message}
            onConfirm={confirmModalConfig.onConfirm}
            confirmText={confirmModalConfig.confirmText}
            cancelText={confirmModalConfig.cancelText}
            className='confirm-modal'
            size='sm'
        />
        <PreviewModal
            show={!!previewMedia}
            onHide={() => setPreviewMedia(null)}
            previewMedia={previewMedia}
        />
    </>)
}

export default UserDetails